module.exports = "//static.hsappstatic.net/ecosystem-marketplace-core/static-1.5130/img/storefront-header-blobs.svg"